import { render } from "./BidSheetsLinks.vue?vue&type=template&id=1ffa4e4c&ts=true"
import script from "./BidSheetsLinks.vue?vue&type=script&lang=ts"
export * from "./BidSheetsLinks.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__